/*  ========================================================================
    # Components - Lazy Source
    ========================================================================  */

import React from 'react';
import PropTypes from 'prop-types';

const LazySource = ({ customMedia, mediaMin, visible, srcSet }) => {
  return (
    <source
      media={customMedia ? customMedia : `(min-width: ${mediaMin})`}
      srcSet={visible ? srcSet : null}
    />
  );
};

LazySource.propTypes = {
  customMedia: PropTypes.string,
  mediaMin: PropTypes.string,
  visible: PropTypes.bool,
  srcSet: PropTypes.string
};

export default LazySource;
